import { render, staticRenderFns } from "./smeKycInfo.vue?vue&type=template&id=24054b14&scoped=true&"
import script from "./smeKycInfo.vue?vue&type=script&lang=js&"
export * from "./smeKycInfo.vue?vue&type=script&lang=js&"
import style0 from "./smeKycInfo.vue?vue&type=style&index=0&id=24054b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24054b14",
  null
  
)

export default component.exports